import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("video", {
      controls: "",
      src: _ctx.src,
      muted: "",
      ref: "video",
      loop: "",
      preload: "auto",
      style: _normalizeStyle(_ctx.style)
    }, null, 12, _hoisted_1)
  ]))
}